import { Directive, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { OrderingOption } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { getCurrentUserIsTrueSystemUser } from 'src/app/authentication/state/authentication.selector';
import { Register } from 'src/app/common-components/register/models/register';
import { getCallDetailsPrivileges, getExtensionPrivileges } from 'src/app/privileges/privileges.selector';
import { ExtensionsPrivileges } from './models/extensions-privileges';
import { CallParkingLotFilterOptions } from './models/call-parking-filter-option';
import { CallParkingLotRegisterListItem } from './models/call-parkinglot-register-results.model';
import { callParkingLotRegisterAdapterActions, callParkingLotsRegisterInitialFilter } from './state/call-parkinglot-register.actions';
import * as callLogsRegisterReducer from './state/call-parkinglot-register.reducer';
import { CallParkingRegisterOptions } from './models/call-parkinglot-register-options';

@Directive()
export class CallParkingLotRegister
   extends Register<CallParkingLotRegisterListItem, CallParkingRegisterOptions, OrderingOption>
   implements OnInit
{
   columns: string[];

   filters: CallParkingLotFilterOptions[];

   entityName = 'Parking Lot';

   extensionPrivileges$: Observable<ExtensionsPrivileges>;

   isSystemUser$: Observable<boolean>;

   constructor(public store: Store) {
      super(store, callLogsRegisterReducer.selectors, callParkingLotRegisterAdapterActions);
      this.extensionPrivileges$ = store.pipe(select(getExtensionPrivileges));
      this.isSystemUser$ = store.pipe(select(getCurrentUserIsTrueSystemUser));
   }

   ngOnInit() {
      this.store.dispatch(callParkingLotsRegisterInitialFilter({ filters: this.filters }));
      this.store.dispatch(this.actions.pageEnter());
   }
}
